// These are used to generate the QR codes
// Not sure how we can handle this better.
// Do we need to add a resolver for this?

const SITE_MAPPING = {
  '623cae393e12545fe0ec4130': 'https://maxime-bottleshow.netlify.app/',
};

export default SITE_MAPPING;
